import { z } from 'zod'
import { oc } from '@orpc/contract'

// Groups of pages and the chart each is being filed to. A group without `pages` is the whole fax
// (the single triage form). Shared by the check and the review that records staff confirmed it.
export const faxPatientCheckInput = z.object({
  id: z.string(),
  groups: z
    .array(
      z.object({
        pages: z.array(z.number().int().positive()).optional(),
        patientId: z.string().min(1),
      }),
    )
    .min(1)
    .max(50),
})

// What staff should check before filing a fax (PD-2049): per group, the pages whose OCR read names
// someone other than its chart, and those that name no patient (PD-2055). `needsReview`: staff must confirm before filing (PD-2053).
// Read-only; `dob` is MM/DD/YYYY.
export const checkIncomingFaxPatients = oc
  .route({ method: 'POST', path: '/v2/incoming-faxes/{id}/patient-check' })
  .input(faxPatientCheckInput)
  .output(
    z.object({
      needsReview: z.boolean(),
      groups: z.array(
        z.object({
          chart: z.object({ display: z.string(), dob: z.string().nullable() }),
          mismatches: z.array(
            z.object({
              pages: z.array(z.number().int()),
              name: z.string(),
              dob: z.string().nullable(),
            }),
          ),
          unnamedPages: z.array(z.number().int()),
        }),
      ),
    }),
  )
